import React, { Component } from 'react';
import { connect } from 'react-redux'

import { addHours } from '../reducers/manageHours'


import { FormControl } from 'react-bootstrap'

const setHourToFixed = hour => {
	const hourAsNum = Number(hour)
	return isNaN(hourAsNum) ? 0.00 : hourAsNum.toFixed(2)
}

class Hours extends Component {

	state = {
		hour: setHourToFixed(this.props.hour),
	}

	componentDidUpdate(prevProps) {
		// If input hours are cleared
		if (this.props.hour !== this.state.hour && prevProps.hour !== this.props.hour) {
			this.setState({ hour: setHourToFixed(this.props.hour) })
		}
	}

	handleChange = (event) => {
		if (this.props.readOnly) {
			return
		}
		return this.setState({ [event.target.name]: event.target.value })
	}

	handleHourInput = (e) => {
		// parentObjectName is the type of hour ex 'project' or 'proposal'
		//  parentObject is the actual project/proposal the hour is associated with
		const { parentObject, parentObjectName, date, type, currentUser, readOnly } = this.props

		if (readOnly) {
			return
		}

		let hours = Number(e.target.value)

		// if (hours < 0 || !e.target.value) {
		// 	hours = 0
		// } else if (hours > 24) {
		// 	hours = 24
		// }
		
		if (!e.target.value) {
			hours = 0
		}

		if (!isNaN(hours)) {
			hours = hours.toFixed(2)
		}

		let { projectHours, proposalHours } = this.props

		const foundHour = [...projectHours, ...proposalHours].find(hour => {
			const datesAreEqual = new Date(hour.date.replace(/-/g, "/")).toLocaleDateString() === new Date(date).toLocaleDateString()

			const parentObjectsAreEqual = !!hour[parentObjectName] && hour[parentObjectName].id === parentObject.id

			const typesAreEqual = hour.type === type

			return datesAreEqual && parentObjectsAreEqual && typesAreEqual
		})


		const newHour = { [parentObjectName]: parentObject, date, type, hours, currentUser }

		if (!foundHour && newHour.hours === 0) {
			return
		}

		this.props.addHours(newHour)
	}

	render() {
		return (
			<td style={{textAlign:"center", borderRight:"thin solid #dcdbdc", verticalAlign:"middle"}}>
				<FormControl
					style={{textAlign: "center"}}
					className="hour-input"
					name="hour"
					type="number"
					step={0.5}
					value={this.state.hour}
					onChange={this.handleChange}
					onBlur={this.handleHourInput}
					readOnly={this.props.readOnly}
				/>
			</td>
		)
	}
}

const mapStateToProps = (state) => {
  return {
	inputtedHours: state.manageHours.inputtedHours,
    projectHours: state.manageHours.projectHours,
    proposalHours: state.manageHours.proposalHours,
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps, { addHours })(Hours);



// WEBPACK FOOTER //
// ./src/routes/workload/components/Hours.js